/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Invalid_ScoreInputs */



/**
* | output |
* | --- |
* | "Invalid score: impossible VP combination for this table" |
*
* @param {Err_Tournament_Invalid_ScoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_invalid_score = /** @type {((inputs?: Err_Tournament_Invalid_ScoreInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Invalid_ScoreInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Score invalide : combinaison de VP impossible pour cette table")
	if (locale === "es") return /** @type {LocalizedString} */ ("Puntuación no válida: combinación de VP imposible para esta mesa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pontuação inválida: combinação de VP impossível para esta mesa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punteggio non valido: combinazione di VP impossibile per questo tavolo")
	return /** @type {LocalizedString} */ ("Invalid score: impossible VP combination for this table")
});